<script setup lang="ts">
/**
 * モーダル表示用コンポーネント。
 * 本プロジェクト内部でモーダル要素を利用する場合は、原則このコンポーネントを使用する事。
 */

import { reactive, toRefs, defineExpose } from "vue";

interface State {
	/**
	 * モーダル開閉状態。
	 */
	isOpen: boolean;
}
// reactiveな変数宣言
const state = reactive<State>({
	isOpen: false,
});
const { isOpen } = toRefs(state);

/**
 * モーダルを開く処理。
 * 親コンポーネントから`ref`を使い、当メソッドを呼び出してモーダルを開くこと。
 */
const openModal = (): void => {
	state.isOpen = true;
};

// モーダルを閉じる処理
const closeModal = (): void => {
	state.isOpen = false;
};

defineExpose({
	openModal,
});
</script>

<template>
	<!-- 画面全体のオーバーレイ -->
	<div :class="`revico-community-talk-modal-overlay ${isOpen ? 'revico-community-talk-modal-open' : ''}`">
		<div class="revico-community-talk-modal-wrapper">
			<!-- モーダル内部コンテンツ -->
			<div class="revico-community-talk-modal-contents">
				<slot name="contents"></slot>
				<!-- モーダル閉じるボタン -->
				<button class="revico-community-talk-modal--close-btn" @click="closeModal"></button>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-modal {
		// 画面全体のオーバーレイ
		&-overlay {
			position: fixed;
			top: 0px;
			left: 0px;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.8);
			opacity: 0;
			z-index: -1;
			transition: 0.2s;
			overscroll-behavior: contain;
		}
		&-open {
			opacity: 1;
			z-index: 9999;
		}

		&-wrapper {
			width: 100%;
			height: 100%;
			overflow: hidden;
		}

		// モーダル内部コンテンツ
		&-contents {
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 90%;
			max-width: 1000px;
			height: 100%;
			margin: auto;
		}

		// モーダル閉じるボタン
		&--close-btn {
			position: absolute;
			top: 24px;
			right: 24px;
			width: 36px;
			height: 36px;
			background: none;
			border: none;
			cursor: pointer;
			&::before,
			&::after {
				content: "";
				display: inline-block;
				position: absolute;
				top: 2px;
				width: 2px;
				height: 30px;
				border-radius: 2px;
				background-color: #fff;
			}
			&::before {
				transform: rotate(45deg);
			}
			&::after {
				transform: rotate(-45deg);
			}
		}
	}
}

/* PC対応 */
@media screen and (min-width: 769px) {
	.revico-widget .revico-community-talk .revico-community-talk {
		&-modal {
			// モーダル内部コンテンツ
			&-contents {
				width: 80%;
			}
			// モーダル閉じるボタン
			&--close-btn {
				top: 10%;
				right: 20%;
			}
		}
	}
}
</style>
